module.exports = __webpack_public_path__ + "img/section-3-content_2_t_img.c37ba49c.png";